import '../styles/index.less';
import { SVGMask } from './svg-mask.js';
import { FilterAgenda } from '../../dekubus/js/filter-agenda.js';
import { interactiveMap } from './interactive-map.js';

var init = {};

init.sync = function() {
	SVGMask.init();
	FilterAgenda.init();

	// multiply fix:
	// if (window.getComputedStyle(document.body).mixBlendMode !== undefined) {
  //   //$("div.img").addClass("curtain");
	// 	console.log('fix');
	// }
}

init.aSync = function() {
	initInteractiveMap();
}

const initInteractiveMap = function() {
	if ( $( '.js-interactive-map' ).length > 0 ) {
		import(
			'./interactive-map.js'
		).then(module => {
			aSync.interactiveMap = module.interactiveMap;
			aSync.interactiveMap.init();
		}).catch(error => 'An error occurred while loading the component');
	}
};

$(function() {
	init.sync();
	init.aSync();
});
